import { type ImageObject, ImageObjectSchema } from './imageObject'
import {
  defineCborSchema,
  CborField,
  type CborSchema,
} from '@mesh/friendly-cbor-serializer'

export type ApplicationConsumerSummary = {
  id?: Uint8Array
  name: string
  description?: string
  logos: ImageObject[]
  createDate?: string
  updateDate?: string
  idpToSpUrl?: string
}

export const ApplicationConsumerSummarySchema: CborSchema<ApplicationConsumerSummary> =
  defineCborSchema<ApplicationConsumerSummary>({
    id: CborField({ key: 0, required: false }),
    name: CborField({ key: 1 }),
    description: CborField({ key: 2, required: false }),
    logos: CborField({ key: 3, arrayItemType: ImageObjectSchema }),
    createDate: CborField({ key: 4, required: false }),
    updateDate: CborField({ key: 5, required: false }),
    idpToSpUrl: CborField({ key: 6, required: false }),
  })
